export default "__VITE_ASSET__DPGAoz_H__"